import React from "react";
import { useLoaderData, useLocation, useParams } from "react-router";

import classNames from "classnames";

import GameLogTable from "./components/GameLogTable";

import "../../../assets/css/umphub/pages/admin.scss";
import { getGameLogs, getPlaceholderGameLogs } from "../../../lib/api";
import { IGameLog } from "../../../types/api";

export const loader = async ({ request, params }: any) => {
    const { gameId } = params;

    let logs: IGameLog[];

    if (gameId) {
        const result = await getGameLogs(gameId);
        logs = result.logs;
    } else {
        const url = new URL(request.url);
        const searchParams = url.searchParams;

        const tournamentId = searchParams.get("tournamentId");
        const date = searchParams.get("date");
        const field = searchParams.get("field");
        const diamond = searchParams.get("diamond");
        const result = await getPlaceholderGameLogs(
            tournamentId,
            date,
            field,
            diamond,
        );
        logs = result.logs;
    }
    return {
        logs,
    };
};

const GameLogs = (): React.JSX.Element => {
    const { logs } = useLoaderData() as {
        logs: IGameLog[];
    };

    const gameLogs = logs.filter(l => l.category !== "Umpire");
    const umpireLogs = logs.filter(l => l.category === "Umpire");

    return (
        <>
            <h3 className={classNames("mb-0")}>Game History</h3>
            <GameLogTable data={gameLogs} />
            <h3 className={classNames("mt-3", "mb-0")}>Umpire History</h3>
            <GameLogTable data={umpireLogs} />
        </>
    );
};

export default GameLogs;
